import styled from "styled-components";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledAccordion,
} from "reactstrap";

import PrimaryWebThemeForm from "../../forms/web/PrimaryWebThemeForm";

const Container = styled.div`
  height: calc(100vh - 74px);
  padding: 10px;
  overflow: scroll;
`;

const WLThemeSection = {
  Colors: "colors",
  Fonts: "fonts",
};

export default function WebSideBar() {
  return (
    <Container className="SideBar">
      <UncontrolledAccordion defaultOpen={WLThemeSection.Colors}>
        <AccordionItem>
          <AccordionHeader targetId={WLThemeSection.Colors}>
            <span>Colors</span>
          </AccordionHeader>
          <AccordionBody accordionId={WLThemeSection.Colors}>
            <PrimaryWebThemeForm />
          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId={WLThemeSection.Fonts}>
            <span>Fonts</span>
          </AccordionHeader>
          <AccordionBody accordionId={WLThemeSection.Fonts}></AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>
    </Container>
  );
}
